const SearchBarStyle = {
  textField: {
    border: "inherit",
    boxShadow: "0 0.25rem 0.75rem 0rem rgba(0, 0, 0, 0.07)",
    borderRadius: "0.9375rem",
    marginBottom: "1.5625rem",
  },
};
export default SearchBarStyle;
